import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PasajerosService {
  @Output() idpaquete: EventEmitter<any> = new EventEmitter();
  httpHeaders = new HttpHeaders({
  });


  constructor(private http: HttpClient) { }

  pasajerosFind(estado: string, texto: string): Observable<any> {
    const data: FormData = new FormData();
    data.append("estado", estado);
    data.append("search", texto);
    const getRequest = new HttpRequest('POST', environment.api + 'api/pasajeros/get',data, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  pasajerosAgenciaSearch(user: string, search: string, estado: string): Observable<any> {
    const data: FormData = new FormData();
    data.append("user", user);
    data.append("search", search);
    data.append("estado", estado);

    const getRequest = new HttpRequest('POST', environment.api + 'api/pasajero/getPasajerosAgenciaSearch', data, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  pasajerosSearch(form): Observable<any> {
    const data: FormData = new FormData();
    data.append("search", form.search.value);
    data.append("destino", form.destino.value);
    data.append("fecha", form.fecha.value);
    data.append("sinpago", form.sinpago.value);
    data.append("pagoparcial", form.pagoparcial.value);
    data.append("pagototal", form.pagototal.value);

    const getRequest = new HttpRequest('POST', environment.api + 'api/pasajero/getPasajerosSearch', data, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  pasajerosImport(json): Observable<any> {
    const data = JSON.stringify(json);
    const getRequest = new HttpRequest('POST', environment.api + 'api/pasajero/pasajerosImport', data, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  pasajeroUpdate(idPaquete: Number, nombre: string, telefono: string, email: string, tipoDocumento: string,
                 numeroDocumento: string, observaciones: string, nombreEmergencia: string, telefonoEmergencia: string, facebook: string,
                 twitter: string, instagram: string, habitacion: string, pagado: string, documento: any, ficha: any, ): Observable<any> {

    const data: FormData = new FormData();
    for(let x = 0; x < documento.length; x++) {
      data.append("documento", documento[x].file);
    }
    for(let x = 0; x < ficha.length; x++) {
      data.append("ficha", ficha[x].file);
    }
    data.append("nombre", nombre);
    data.append("telefono", telefono);
    data.append("email", email);
    data.append("tipoDocumento", tipoDocumento);
    data.append("numeroDocumento", numeroDocumento);
    data.append("observaciones", observaciones);
    data.append("nombreEmergencia", nombreEmergencia);
    data.append("telefonoEmergencia", telefonoEmergencia);
    data.append("facebook", facebook);
    data.append("twitter", twitter);
    data.append("instagram", instagram);
    data.append("habitacion", habitacion);
    data.append("pagado", pagado);

    const getRequest = new HttpRequest('POST', environment.api + 'api/pasajero/update?id='+idPaquete, data, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  pasajeroUpdateDetalles(idPasajero: Number, nombre: string, telefono: string, email: string, tipoDocumento: string, numeroDocumento: string, pagado: string, fechaNacimiento: string): Observable<any> {

    const data: FormData = new FormData();
    data.append("nombre", nombre);
    data.append("telefono", telefono);
    data.append("email", email);
    data.append("tipoDocumento", tipoDocumento);
    data.append("numeroDocumento", numeroDocumento);
    data.append("pagado", pagado);
    data.append("fecha_nacimiento", fechaNacimiento);

    const getRequest = new HttpRequest('POST', environment.api + 'api/pasajero/updateDetalles?id='+idPasajero, data, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }
}

